// AUTOGENERATED FILE - DO NOT EDIT

export const LANGUAGE_TITLES: Record<number, string> = {
	1:  "English",
	2:  "Español",
	3:  "Français",
	4:  "русский язык",
	5:  "Hmoob",
	6:  "Af-Soomaali",
	7:  "English (UK)",
	8:  "普通话",
	9:  "Mvskoke",
	10: "Yavapai",
	11: "Cheyenne Arapaho",
	12: "Cymraeg",
	13: "Choctaw",
	14: "kreyòl ayisyen",
	15: "Tiếng việt",
	16: "Mixteco (Tuún Saavi / Tuún ntávi)",
	17: "Irish",
	18: "Deutsch",
	19: "हिन्दी",
	20: "日本語",
	21: "한국어",
};
export const LanguageCodes: Record<number, string> = {
	1:  "en-US",
	2:  "es",
	3:  "fr",
	4:  "ru",
	5:  "hmn",
	6:  "so",
	7:  "en-GB",
	8:  "zh",
	9:  "mus",
	10: "yuf",
	11: "arp",
	12: "cy",
	13: "cho",
	14: "hat",
	15: "vie",
	16: "mim",
	17: "ga",
	18: "de",
	19: "hi",
	20: "ja",
	21: "ko-KR",
};
